import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { AccordionModule } from "primeng/accordion";
import { AutoCompleteModule } from "primeng/autocomplete";
import { ButtonModule } from "primeng/button";
import { BadgeModule } from "primeng/badge";
import { CalendarModule } from "primeng/calendar";
import { CardModule } from "primeng/card";
import { CheckboxModule } from "primeng/checkbox";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { FieldsetModule } from "primeng/fieldset";
import { FileUploadModule } from "primeng/fileupload";
import { GalleriaModule } from "primeng/galleria";
import { InputTextModule } from "primeng/inputtext";
import { InputNumberModule } from "primeng/inputnumber";
import { InputTextareaModule } from "primeng/inputtextarea";
import { KeyFilterModule } from "primeng/keyfilter";
import { ListboxModule } from "primeng/listbox";
import { MenuModule } from "primeng/menu";
import { MessagesModule } from "primeng/messages";
import { MultiSelectModule } from "primeng/multiselect";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { PanelModule } from "primeng/panel";
import { PanelMenuModule } from "primeng/panelmenu";
import { PasswordModule } from "primeng/password";
import { PickListModule } from "primeng/picklist";
import { MessageModule } from "primeng/message";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { ProgressBarModule } from "primeng/progressbar";
import { RadioButtonModule } from "primeng/radiobutton";
import { SelectButtonModule } from "primeng/selectbutton";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { SliderModule } from "primeng/slider";
import { TableModule } from "primeng/table";
import { TabViewModule } from "primeng/tabview";
import { ToastModule } from "primeng/toast";
import { TooltipModule } from "primeng/tooltip";
import { TreeModule } from "primeng/tree";
import { TreeTableModule } from "primeng/treetable";
import { EditorModule } from "primeng/editor";
import { TabMenuModule } from "primeng/tabmenu";
import { SidebarModule } from "primeng/sidebar";
import { MenubarModule } from "primeng/menubar";
import { InputSwitchModule } from "primeng/inputswitch";
import { SplitButtonModule } from "primeng/splitbutton";
import { DataViewModule } from "primeng/dataview";
import { TieredMenuModule } from "primeng/tieredmenu";
import { StepsModule } from "primeng/steps";
import { DragDropModule } from "primeng/dragdrop";
import { ToggleButtonModule } from "primeng/togglebutton";
import { ChipsModule } from "primeng/chips";
import { ChipModule } from "primeng/chip";
import { SplitterModule } from "primeng/splitter";
import { FloatLabelModule } from "primeng/floatlabel";
import { InputGroupModule } from "primeng/inputgroup";
import { InputGroupAddonModule } from "primeng/inputgroupaddon";
import { TimesIcon } from "primeng/icons/times";
import { IconFieldModule } from "primeng/iconfield";
import { InputIconModule } from "primeng/inputicon";

@NgModule({
    imports: [
        CommonModule,
        AccordionModule,
        AutoCompleteModule,
        ButtonModule,
        BadgeModule,
        CalendarModule,
        CardModule,
        CheckboxModule,
        ConfirmDialogModule,
        DialogModule,
        DropdownModule,
        EditorModule,
        FieldsetModule,
        FileUploadModule,
        GalleriaModule,
        InputGroupModule,
        InputGroupAddonModule,
        InputTextModule,
        InputNumberModule,
        InputTextareaModule,
        KeyFilterModule,
        ListboxModule,
        MenuModule,
        MenubarModule,
        MessagesModule,
        MultiSelectModule,
        OverlayPanelModule,
        PanelModule,
        PanelMenuModule,
        PasswordModule,
        PickListModule,
        MessageModule,
        ProgressSpinnerModule,
        SelectButtonModule,
        SelectButtonModule,
        ProgressBarModule,
        RadioButtonModule,
        ScrollPanelModule,
        SidebarModule,
        SliderModule,
        SplitButtonModule,
        TableModule,
        TabViewModule,
        TabMenuModule,
        TieredMenuModule,
        ToastModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
        MenubarModule,
        ToggleButtonModule,
        ChipModule,
        ChipsModule,
        SplitterModule,
        FloatLabelModule,
        TimesIcon,
        IconFieldModule,
        InputIconModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        AccordionModule,
        AutoCompleteModule,
        ButtonModule,
        BadgeModule,
        CalendarModule,
        CardModule,
        CheckboxModule,
        ConfirmDialogModule,
        DialogModule,
        DropdownModule,
        DataViewModule,
        EditorModule,
        FieldsetModule,
        FileUploadModule,
        GalleriaModule,
        InputGroupModule,
        InputGroupAddonModule,
        InputTextModule,
        InputNumberModule,
        InputTextareaModule,
        InputSwitchModule,
        KeyFilterModule,
        ListboxModule,
        MenuModule,
        MenubarModule,
        MessagesModule,
        MultiSelectModule,
        OverlayPanelModule,
        PanelModule,
        PanelMenuModule,
        PasswordModule,
        PickListModule,
        MessageModule,
        ProgressSpinnerModule,
        SelectButtonModule,
        SelectButtonModule,
        ProgressBarModule,
        RadioButtonModule,
        ScrollPanelModule,
        SidebarModule,
        SliderModule,
        SplitButtonModule,
        StepsModule,
        TableModule,
        TabViewModule,
        TabMenuModule,
        TieredMenuModule,
        ToastModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
        DragDropModule,
        ToggleButtonModule,
        ChipModule,
        ChipsModule,
        SplitterModule,
        FloatLabelModule,
        TimesIcon,
        IconFieldModule,
        InputIconModule
    ]
})
export class PrimeNgModule {}
